<!--
 * @Author: v_aydwang
 * @Date: 2022-12-23 16:21:12
 * @LastEditors: v_aydwang
 * @LastEditTime: 2023-01-05 15:23:19
 * @Description: 大屏-卡片信息
-->
<template>
  <div id="card_assembly">
    <div>
      <div class="card-one">
        <div class="titlt-top">
          <p class="titlt">质量</p>
          <div
            :class="cardData.zl_count > 0 ? 'time-warn' : 'time-normal'"
            @click="warnClick"
          >
            <span></span>
            <div v-if="cardData.zl_count > 0">
              <Marquee
                :text="`周期内触发 ${cardData.zl_count} 次质量预警，需要关注`"
              >
              </Marquee>
            </div>
            <div v-else style="cursor: default">周期内未触发质量预警</div>
          </div>
        </div>
        <div class="titlt-con">
          <div class="con">
            <p class="left-one">指标详情</p>
            <countTo class="left-two" :val="cardData.zl">
              <span>%</span>
            </countTo>
            <p class="left-three">目标值{{ cardData.zl_standard || 0 }}%</p>
            <!-- <p class="left-three">月环比<span>+10%</span></p> -->
          </div>
          <div class="con-little">
            <p class="left-one">学考联动</p>
            <countTo class="left-two" :val="dispatch.count || 0" />
            <p class="left-three">触发次数</p>
          </div>
          <div class="con">
            <p class="left-one" style="opacity: 0">时间</p>
            <countTo class="left-two" :val="dispatch.cost_time || 0">
              <span class="hour">h</span>
            </countTo>
            <p class="left-three" style="margin-top:-1px">学习时长</p>
          </div>
        </div>
        <div class="titlt-bottom">
          <div style="width:100%">
            <p class="title">错误场景TOP3</p>
            <a-carousel dot-position="right" autoplay>
              <p class="con" v-for="(item, index) in errorlist" :key="index">
                TOP{{ Number(index) + 1 }} {{ item.error_name }} <span>{{ item.error_count }}次</span>
              </p>
            </a-carousel>
          </div>
        </div>
      </div>
      <cardModules
        class="card-two"
        :cardInfo="{
          title: '有效时长',
          con: '有效时长',
          count: warn.hs_count,
          value: cardData.hs,
          standard: cardData.hs_standard || 0,
          rank: rank.hs_rank || 0,
          totalRank: rank.hs_totalRank || 0,
          image: rank.hs_label,
          backStyle: require('../../../assets/personnel-large/leftBot.png')
        }"
      ></cardModules>
      <cardModules
        class="card-three"
        :cardInfo="{
          title: '效率',
          con: '制作效率',
          count: warn.xl_count,
          value: cardData.xl,
          standard: cardData.xl_standard || 0,
          rank: rank.xl_rank || 0,
          totalRank: rank.xl_totalRank || 0,
          image: rank.xl_label,
          backStyle: require('../../../assets/personnel-large/rightTop.png')
        }"
      ></cardModules>
      <cardModules
        class="card-four"
        :cardInfo="{
          title: '产量',
          con: '制作产量',
          count: warn.cl_count,
          value: cardData.cl,
          standard: cardData.cl_standard || 0,
          rank: rank.cl_rank || 0,
          totalRank: rank.cl_totalRank || 0,
          image: rank.cl_label,
          backStyle: require('../../../assets/personnel-large/rightBot.png')
        }"
      ></cardModules>
    </div>
    <earlyWarning :warnVisible="warnVisible">
      <template v-slot:close>
        <div @click="closeModal" class="close-x"></div>
      </template>
    </earlyWarning>
  </div>
</template>

<script>
import earlyWarning from './earlyWarning.vue';
import cardModules from '@/components/CardModules';
import Marquee from '@/components/Marquee';
import countTo from '@/components/numGif';
import {
  getWarn,
  getRank,
  getDispatch,
  getDispatchError,
} from '@/api/personnelLarge.js';

export default {
  components: {
    earlyWarning,
    cardModules,
    Marquee,
    countTo,
  },
  props: {
    cardData: {
      type: Object,
      default: () => ({

      }),
    },
    searchParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      warnVisible: false,
      rankingImage: {
        头部: require('../../../assets/personnel-large/rank1.png'),
        中上等: require('../../../assets/personnel-large/rank2.png'),
        中等: require('../../../assets/personnel-large/rank3.png'),
        中下等: require('../../../assets/personnel-large/rank4.png'),
        尾部: require('../../../assets/personnel-large/rank5.png'),
      },
      warn: {},
      rank: {},
      dispatch: {},
      errorlist: [],
    };
  },
  watch: {
    searchParams(val) {
      this.warn = {};
      this.rank = {};
      this.dispatch = {};
      this.errorlist = [];
      if (val.production_line_code) {
        this.init();
      }
    },
  },
  mounted() {
  },
  methods: {
    init() {
      getDispatchError({ ...this.searchParams }).then((res) => {
        this.$nextTick(() => {
          this.errorlist = [...res];
        });
      });
      getWarn({ ...this.searchParams }).then((res) => {
        this.warn = { ...res };
      });
      getRank({ ...this.searchParams }).then((res) => {
        this.rank = {
          ...res,
          hs_rank: res.hs_rank.split('/')[0],
          hs_totalRank: res.hs_rank.split('/')[1],
          xl_rank: res.xl_rank.split('/')[0],
          xl_totalRank: res.xl_rank.split('/')[1],
          cl_rank: res.cl_rank.split('/')[0],
          cl_totalRank: res.cl_rank.split('/')[1],
        };
      });
      getDispatch({ ...this.searchParams }).then((res) => {
        this.dispatch = { ...res };
      });
    },
    warnClick() {
      // this.warnVisible = true;
    },
    closeModal() {
      this.warnVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/convert-viewport";
@import "@/styles/cardAssembly";

#card_assembly {
  .card-one {
    width: vw(454);
    height: vh(264);
    padding: vh(24) vw(20) vh(10) vw(46);
    .titlt-top {
      margin-bottom: vh(14);
      .titlt {
        font-size: vw(20);
        line-height: vh(28);
        margin-right: vw(18);
      }
      .normal,
      .warn,
      .time-warn,
      .time-normal {
        height: vh(40);
        font-size: vw(14);
        line-height: vh(40);
        padding-left: vw(20);
        position: relative;
        display: flex;
        align-items: center;
        min-width: vw(290);
        span {
          width: vw(18);
          height: vh(18);
          margin-right: vw(4);
          vertical-align: sub;
        }
      }
    }
    .titlt-con {
      margin-top: vh(5);
      .con {
        width: vw(130);
      }
      .con-little {
        width: vw(100);
      }
      .con,
      .con-little {
        .left-one {
          font-size: vw(14);
          line-height: vh(30);
        }
        .left-two {
          font-size: vw(28);
          line-height: vh(34);
          span {
            margin-left: vw(-7);
          }
          .hour {
            font-size: vw(14);
            line-height: vh(26);
            margin-left: vw(-3);
          }
        }
        .left-three {
          font-size: vw(14);
          line-height: vh(18);
          span {
            font-size: vw(14);
            line-height: vh(22);
          }
        }
      }
    }
    .titlt-bottom {
      margin-top: vh(14);
      .rank-con {
        width: vw(130);
      }
      div {
        .title {
          font-size: vw(14);
          line-height: vh(22);
        }
        .con {
          font-size: vw(14);
          line-height: vh(22);
          span {
            font-size: vw(14);
            line-height: vh(22);
          }
        }
        .number {
          font-size: vw(32);
          line-height: vh(32);
          span {
            font-size: vw(16);
            line-height: vh(32);
          }
        }
        .rank {
          width: vw(60);
          height: vh(44);
          margin-top: vh(-4);
        }
      }
    }
  }
  .card-one {
    left: vw(20);
    top: vh(-35);
  }
  .card-two {
    left: vw(74);
    top: vh(258);
  }
  .card-three {
    right: vw(476);
    top: vh(-35);
  }
  .card-four {
    right: vw(526);
    top: vh(258);
  }
}
.close-x {
  width: vw(32);
  height: vw(32);
  background: url("../../../assets/personnel-large/close.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: vh(8);
  right: vw(10);
  cursor: pointer;
}
p {
  margin-bottom: 0;
}
</style>
<style lang="less" scoped>
/deep/.ant-carousel-vertical .slick-dots-right {
  display: none !important;
}

</style>
